<div class="px-[30px] py-6 flex flex-col gap-5">
    <div class="flex justify-between border-b border-gray-300 pb-4 items-start">
        <h2 class="text-2xl font-bold text-black m-0">{{ title }}</h2>
        <button (click)="close()" class="hover:bg-gray-100 active:bg-gray-200 transition-colors rounded -mr-2.5 px-2 py-1 flex items-center justify-center">
            <i class="fas fa-xmark text-2xl"></i>
        </button>
    </div>

    <ng-content />
</div>
